const LOAD_LAYOUTSLOGS = "LOAD_LAYOUTSLOGS";
const LOAD_LAYOUTSLOGS_SUCCESS = "LOAD_LAYOUTSLOGS_SUCCESS";
const LOAD_LAYOUTSLOGS_FAIL = "LOAD_LAYOUTSLOGS_FAIL";

const LOAD_TABSLOGS = "LOAD_TABSLOGS";
const LOAD_TABSLOGS_SUCCESS = "LOAD_TABSLOGS_SUCCESS";
const LOAD_TABSLOGS_FAIL = "LOAD_TABSLOGS_FAIL";

const LOAD_FILTERSLOGS = "LOAD_FILTERSLOGS";
const LOAD_FILTERSLOGS_SUCCESS = "LOAD_FILTERSLOGS_SUCCESS";
const LOAD_FILTERSLOGS_FAIL = "LOAD_FILTERSLOGS_FAIL";

const LOAD_MENUITEMSLOGS = "LOAD_MENUITEMSLOGS";
const LOAD_MENUITEMSLOGS_SUCCESS = "LOAD_MENUITEMSLOGS_SUCCESS";
const LOAD_MENUITEMSLOGS_FAIL = "LOAD_MENUITEMSLOGS_FAIL";

const LOAD_SOURCELOGS = "LOAD_SOURCELOGS";
const LOAD_SOURCELOGS_SUCCESS = "LOAD_SOURCELOGS_SUCCESS";
const LOAD_SOURCELOGS_FAIL = "LOAD_SOURCELOGS_FAIL";

export default function analytics(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
  },
  action,
) {
  switch (action.type) {
    case LOAD_LAYOUTSLOGS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_LAYOUTSLOGS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_LAYOUTSLOGS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    case LOAD_TABSLOGS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_TABSLOGS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_TABSLOGS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    case LOAD_MENUITEMSLOGS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_MENUITEMSLOGS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_MENUITEMSLOGS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    case LOAD_FILTERSLOGS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_FILTERSLOGS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_FILTERSLOGS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    case LOAD_SOURCELOGS: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case LOAD_SOURCELOGS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case LOAD_SOURCELOGS_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }
    default:
      return state;
  }
}

export function getLayoutLog(resourceDTO) {
  return {
    type: LOAD_LAYOUTSLOGS,
    payload: {
      request: {
        url: `logger/Layout`,
        method: "POST",
        data: resourceDTO,
      },
    },
  };
}

export function getTabLog(tabDTO) {
  return {
    type: LOAD_TABSLOGS,
    payload: {
      request: {
        url: `logger/Tabs`,
        method: "POST",
        data: tabDTO,
      },
    },
  };
}

export function getSourceLog(resourceDTO) {
  return {
    type: LOAD_SOURCELOGS,
    payload: {
      request: {
        url: `logger/Source`,
        method: "POST",
        data: resourceDTO,
      },
    },
  };
}

export function getFilterLog(filterDTO) {
  return {
    type: LOAD_FILTERSLOGS,
    payload: {
      request: {
        url: `logger/Filter`,
        method: "POST",
        data: filterDTO,
      },
    },
  };
}

export function getMenuItemLog(resourceDTO) {
  return {
    type: LOAD_MENUITEMSLOGS,
    payload: {
      request: {
        url: `logger/MenuItem`,
        method: "POST",
        data: resourceDTO,
      },
    },
  };
}
